import { TOPICS, resolveTopic } from "./svgs"

// `colors` and `order` are derived from the single TOPICS source of truth.
// Backward-compatible: existing `colors[label]` / `order[label]` lookups keep working
// for every label listed in any topic's `labels` array, plus the legacy "Other" bucket.
//
// For wording the editor coins later that isn't in `labels` yet, consumers should
// prefer `resolveTopic(label)?.color` / `.order` (with first-word fallback).

const buildMap = field =>
  Object.fromEntries(
    TOPICS.flatMap(t => t.labels.map(label => [label, t[field]]))
  )

export const colors = { ...buildMap("color"), Other: "#f0f7fb" }
export const order = { ...buildMap("order"), Other: 13 }
export { resolveTopic, TOPICS }
